<template>
  <div
      class="kyra-fixed-bg"
      :style="{ background: colorArrayToLinearGradient(bgColors, 160) }"
  />
</template>

<script>

import { colorArrayToLinearGradient } from "@/utils/UI";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: 'GradientBackground',
  mixins: [ UIMixin ],
  props: {},
  data() {
    return {
      pw: null
    }
  },
  mounted() {
  },

  beforeDestroy() {
  },
  methods: {
    colorArrayToLinearGradient,
  },
  computed: {}
}
</script>
<style scoped lang="scss">

</style>
